import React, {Component} from "react";
import { Row, Col } from 'antd';



export default class CardListFeetching extends Component {

  render() {

    return (
      <div>
        {[...Array(2)].map((x, i) =>
          <Row className={'user-card-container mb-3 flex items-center'}>
            <Col span={2}>
              <div className="gradiant fetching card-img-fetching mb-0"></div>
            </Col>
            <Col span={8}><div className="gradiant fetching mb-0"></div></Col>
            <Col span={3}><div className="gradiant fetching mb-0"></div></Col>
            <Col span={9} className={'h-full flex justify-center items-center'}>
              <div className="gradiant fetching mb-0"></div>
            </Col>
            <Col span={2}><div className="gradiant fetching mb-0"></div></Col>
          </Row>
        )}
      </div>
      );
  }
}




// WEBPACK FOOTER //
// ./app/components/feetching/mangoPay/CardListFeetching.js